// 0.45.50 - "Weight" on Title elements.
//
// Henaket (the default, value '' or unset) keeps each heading level's
// own weight: H1 bold (700), H2 to H6 semibold (600). The admin may
// set Bold or Semibold for one title. Stored as `font_weight`.
// 0.47.16 - And Normal (regular, 400), as body text.

export const TITLE_WEIGHT_OPTIONS = [
  { value: '', label: 'Henaket (default)' },
  { value: 'bold', label: 'Bold' },
  { value: 'semibold', label: 'Semibold' },
  { value: 'normal', label: 'Normal' },
];

const TOKENS = { bold: 'var(--font-weight-bold)', semibold: 'var(--font-weight-semibold)', normal: 'var(--font-weight-regular, 400)' };

// Inline style entries for the title, empty at the Henaket default.
export function titleWeightStyle(e) {
  const t = e && TOKENS[e.font_weight];
  return t ? { fontWeight: t } : {};
}
